import { Component } from 'react';
import { clearBCSID } from '../../utils/BiocatchUtils';
import {
  removeAuthCookie,
  DEFAULT_IB_AUTH_COOKIE_NAME,
} from 'web-lib-application-essentials/lib/cookie';
import { getAuthDomain } from 'web-lib-application-essentials/lib/urlUtil';
import SessionServerActionCreator from '../../actions/SessionServerActionCreator';

class InvalidTokenSessionTimeOutPage extends Component {
  componentWillMount() {
    SessionServerActionCreator.handleSessionTimedOut();
    removeAuthCookie(DEFAULT_IB_AUTH_COOKIE_NAME, getAuthDomain());
  }

  componentDidMount() {
    clearBCSID();
  }

  render() {
    return null;
  }
}

export default InvalidTokenSessionTimeOutPage;
